//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    tag: null,
    title: null,
    subtitle: null
  },
  methods: {
    isLong: function isLong() {
      try {
        if (this.tag.length > 6) {
          return 'is-long';
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    }
  }
};